import { render, staticRenderFns } from "./dictionnaireModal.vue?vue&type=template&id=d23f0ab0&scoped=true"
import script from "./dictionnaireModal.vue?vue&type=script&lang=js"
export * from "./dictionnaireModal.vue?vue&type=script&lang=js"
import style0 from "./dictionnaireModal.vue?vue&type=style&index=0&id=d23f0ab0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d23f0ab0",
  null
  
)

export default component.exports